import validate from './validate.js';

function version(uuid) {
  if (!validate(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.slice(14, 15), 16);
}

export default version;


//////////////////
// WEBPACK FOOTER
// ./~/uuid/dist/esm-browser/version.js
// module id = 2313
// module chunks = 2